// Localization is based on '@ngx-translate/core'
// Please be familiar with official documentation => https://github.com/ngx-translate/core

import { inject, Injectable } from '@angular/core';
import { InterpolatableTranslationObject, TranslateService } from '@ngx-translate/core';

export interface Locale {
	lang: string;
	data: InterpolatableTranslationObject;
}

const LOCALIZATION_LOCAL_STORAGE_KEY = 'language';

@Injectable({
	providedIn: 'root',
})
export class TranslationService {
	private langIds: string[] = [];
	private translate: TranslateService = inject(TranslateService);

	constructor() {
		this.translate.addLangs(['en_EN']);
		this.translate.setDefaultLang('en_EN');
	}

	loadTranslations(...args: Locale[]): void {
		const locales = [...args];

		locales.forEach((locale) => {
			this.translate.setTranslation(locale.lang, locale.data, true);
			this.langIds.push(locale.lang);
		});

		this.translate.addLangs(this.langIds);
		this.translate.use(this.getSelectedLanguage());
	}

	setLanguage(lang: string): void {
		if (lang) {
			this.translate.use(lang);
			localStorage.setItem(LOCALIZATION_LOCAL_STORAGE_KEY, lang);
		}
	}

	getSelectedLanguage(): string {
		return localStorage.getItem(LOCALIZATION_LOCAL_STORAGE_KEY) || this.translate.getDefaultLang();
	}
}
